exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".App_app_7GWKZ{display:block;font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50}.App_app_7GWKZ *{-webkit-box-sizing:border-box;box-sizing:border-box}.App_app_7GWKZ input:focus{outline:0}.App_app_7GWKZ a:empty,.App_app_7GWKZ article:empty,.App_app_7GWKZ div:empty,.App_app_7GWKZ dl:empty,.App_app_7GWKZ h1:empty,.App_app_7GWKZ h2:empty,.App_app_7GWKZ h3:empty,.App_app_7GWKZ h4:empty,.App_app_7GWKZ h5:empty,.App_app_7GWKZ h6:empty,.App_app_7GWKZ p:empty,.App_app_7GWKZ section:empty,.App_app_7GWKZ ul:empty{display:inherit}", ""]);

// exports
exports.locals = {
	"app": "App_app_7GWKZ"
};